module.exports = __webpack_public_path__ + "Poppins-SemiBold.42a21f3f5b33aa4d346d.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-SemiBold.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-SemiBold.woff2
// module chunks = styles